import React, { useEffect, useState } from 'react';
import LayoutWithNavbar from './LayoutWithNavbar';
import { FaEdit, FaPlus, FaTrash } from 'react-icons/fa';
import {
  fetchRoles,
  createRole,
  updateRole,
  deleteRole
} from '../services/api';

const RoleMasterPage = () => {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState({
    open: false,
    mode: 'add',
    role: { id: null, rolename: '', roleid: '', status: 'Active' }
  });

  const loadRoles = async () => {
    setLoading(true);
    const res = await fetchRoles();
    if (res.success) setRoles(res.data);
    else alert(res.message);
    setLoading(false);
  };

  useEffect(() => {
    loadRoles();
  }, []);

  const openModal = (mode, role = { id: null, rolename: '', roleid: '', status: 'Active' }) => {
    setModal({ open: true, mode, role });
  };

  const closeModal = () => {
    setModal({
      open: false,
      mode: 'add',
      role: { id: null, rolename: '', roleid: '', status: 'Active' }
    });
  };

  const handleChange = (e) => {
    setModal({
      ...modal,
      role: { ...modal.role, [e.target.name]: e.target.value }
    });
  };

  const handleSubmit = async () => {
    const { id, rolename, roleid, status } = modal.role;
    if (!rolename.trim() || !roleid.trim()) return alert('Rolename and Role ID are required');

    const payload = { rolename: rolename.trim(), roleid: roleid.trim(), status };

    const res = modal.mode === 'edit'
      ? await updateRole(id, payload)
      : await createRole(payload);

    if (res.success) {
      alert(`Role ${modal.mode === 'edit' ? 'updated' : 'added'} successfully`);
      closeModal();
      loadRoles();
    } else {
      alert(res.message);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this role?')) return;
    const res = await deleteRole(id);
    if (res.success) {
      alert('Role deleted successfully');
      loadRoles();
    } else {
      alert(res.message);
    }
  };

  return (
    <LayoutWithNavbar>
      <div style={styles.container}>
        <h2 style={styles.heading}>Role Master</h2>

        <div style={{ textAlign: 'right', marginBottom: '20px' }}>
          <button style={styles.addButton} onClick={() => openModal('add')}>
            <FaPlus style={{ marginRight: '6px' }} /> New Role
          </button>
        </div>

        {loading ? (
          <p>Loading...</p>
        ) : (
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Role Name</th>
                <th style={styles.th}>Role ID</th>
                <th style={styles.th}>Status</th>
                <th style={styles.th}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {roles.map((role) => (
                <tr key={role.id}>
                  <td style={styles.td}>{role.rolename}</td>
                  <td style={styles.td}>{role.roleid}</td>
                  <td style={styles.td}>{role.status}</td>
                  <td style={styles.td}>
                    <button style={styles.iconButton} onClick={() => openModal('edit', role)}>
                      <FaEdit />
                    </button>
                    <button style={styles.deleteButton} onClick={() => handleDelete(role.id)}>
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {modal.open && (
          <div style={styles.modalBackdrop}>
            <div style={styles.modalBox}>
              <h4>{modal.mode === 'edit' ? 'Edit' : 'Add'} Role</h4>
              <input
                name="rolename"
                placeholder="Role Name"
                value={modal.role.rolename}
                onChange={handleChange}
                style={styles.input}
              />
              <input
                name="roleid"
                placeholder="Role ID"
                value={modal.role.roleid}
                onChange={handleChange}
                style={styles.input}
              />
              <select
                name="status"
                value={modal.role.status}
                onChange={handleChange}
                style={styles.input}
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
              <div style={{ marginTop: '20px' }}>
                <button style={styles.saveButton} onClick={handleSubmit}>Save</button>
                <button style={styles.cancelButton} onClick={closeModal}>Cancel</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </LayoutWithNavbar>
  );
};

const styles = {
  container: { padding: '30px' },
  heading: { fontSize: '24px', fontWeight: '600', marginBottom: '20px' },
  addButton: {
    padding: '10px 16px',
    fontSize: '16px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer'
  },
  table: { width: '100%', borderCollapse: 'collapse', textAlign: 'center' },
  th: { padding: '12px', background: '#333', color: '#fff', fontWeight: '600' },
  td: { padding: '10px', borderBottom: '1px solid #ddd' },
  iconButton: {
    marginRight: '8px',
    padding: '6px 10px',
    backgroundColor: '#ffc107',
    color: '#000',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer'
  },
  deleteButton: {
    padding: '6px 10px',
    backgroundColor: '#dc3545',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer'
  },
  modalBackdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  modalBox: {
    background: '#fff',
    padding: '30px',
    borderRadius: '10px',
    width: '400px',
    textAlign: 'center'
  },
  input: {
    width: '100%',
    padding: '10px',
    margin: '10px 0',
    fontSize: '16px',
    borderRadius: '6px',
    border: '1px solid #ccc'
  },
  saveButton: {
    padding: '10px 20px',
    backgroundColor: '#28a745',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer'
  },
  cancelButton: {
    padding: '10px 20px',
    backgroundColor: '#6c757d',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    marginLeft: '10px',
    cursor: 'pointer'
  }
};

export default RoleMasterPage;
